var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHeartFill = function SvgHeartFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.67 20.32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.19 2.18A6.36 6.36 0 0 0 15.72.13a6.14 6.14 0 0 0-4.6.89 7.38 7.38 0 0 0-.74.56s-.09 0-.27-.14a6.15 6.15 0 0 0-9.06 1.29 6.11 6.11 0 0 0-.44 6.09c.39.81.66 1.15 5 6.35 2.46 3 4.15 5 4.22 5l.27.12a1 1 0 0 0 .9-.21c.18-.16 8.28-9.92 8.5-10.24a6.27 6.27 0 0 0 .88-1.72 6.17 6.17 0 0 0-1.19-5.94Z"
  })));
};
export default SvgHeartFill;